import React, { Component } from 'react';
import { withStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Stack from '@mui/material/Stack';
import AccountCircle from '@mui/icons-material/AccountCircleOutlined';
import Lock from '@mui/icons-material/LockOutlined';
import NormalButton from '@mui/material/Button';
import Hidden from '@mui/material/Hidden';
import USER_ROLES from '../common/userroles';
import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { MultiTabContext } from '../../context/MultiTabContext';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import slider1 from './1.jpg';
import slider2 from './2.jpg';
import slider3 from './3.jpg';
import brandLogo from './brand-logo.svg';
import Logo from '../logo';
import Button from '../button';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Amplify from 'aws-amplify';
import { Auth } from 'aws-amplify';
import { navigate } from '@reach/router';
import mainunit from './background-placement-2x-01.png';
import KaktusTopLogo from './kaktus/kaktus_top.png';
import KaktusMobile from './kaktus/kaktus_mobile.png';
import KaktusConcierge from './kaktus/kaktus_concierge.png';
import KaktusDeliver from './kaktus/kaktus_deliver.png';
import KaktusPoweredByGrey from './kaktus/kaktus_powered_by_grey.png';
import IlocalCurbside from './kaktus/ilocal_curbside.png';
import IlocalKiosk from './kaktus/ilocal_kiosk.png';
import IlocalMail from './kaktus/ilocal_mail.png';
import IlocalCounter from './kaktus/ilocal_counter.png';
import IlocalCourier from './kaktus/ilocal_courier.png';
import IlocalBedside from './kaktus/ilocal_bedside.png';
import KaktusBottom from './kaktus/kaktus_bottom.png';
import spinner from '../assign-prescriptions/images/spinner.gif';
import moment from 'moment-timezone';
import { withTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Link,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Box } from '@mui/system';
import { isFinite } from 'lodash';
import LanguageToggle from '../common/LanguageToggle';
// import { toast } from 'react-toastify';
import CryptoJS from 'crypto-js';
import * as serviceWorker from "../../serviceWorker";
import { writeAuditLog } from '../common/apis';
import { setupTokenExpiryHandler, persistAutoLogoutAccountSetting } from '../../utils/tokenExpiryHandler';
import { checkBrowserDetailsAfterLogin } from '../../utils/browserFingerprint';
import scanQRImg from "./scan.gif"
import ROLES_TYPE from '../enum/role_type';
const AccountsTypeEnum = require('../common/accounts-type').default;
const GroupTypes = require('../common/group-types').default;


const ErrorMessages = {
  InfiniteState: 'User password cannot be reset in the current state.',
  TemporaryExpired: 'Temporary password has expired and must be reset by an administrator.'
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    height: '100vh',
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  paperLeft: {
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },
  paperRight: {
    textAlign: 'right',
    color: theme.palette.text.secondary,
  },
  poweredByLogo: {
    position: 'fixed',
    bottom: 14,
    right: 14,
    height: '2rem',
    width: '10rem',
    '@media only screen and (max-height: 520px)': {
      bottom: 0,
      width: '40%',
    },
  },
  formControl: {
    paddingTop: 5,
    paddingBottom: '1rem',
  },
  ternaryButton: {
    backgroundColor: '#efeded',
    height: '55px',
    width: '45%',
    color: 'black',
    '&:hover': {
      backgroundColor: '#efeded',
      color: 'black',
    },
    '@media only screen and (max-width: 600px)': {
      width: '48%',
      height: '48px',
      fontSize: '0.875rem',
    },
  },
  buttonBar: {
    paddingTop: '1rem',
    minWidth: 300,
    maxWidth: 300,
    marginRight: 'auto',
    marginLeft: 'auto',
    '@media only screen and (max-width: 600px)': {
      minWidth: '100%',
      maxWidth: '100%',
      paddingLeft: '1rem',
      paddingRight: '1rem',
    },
  },
  loginArea: {
    minWidth: 300,
    maxWidth: 340,
    marginLeft: 'auto',
    marginRight: 'auto',
    '@media only screen and (max-width: 600px)': {
      minWidth: '100%',
      maxWidth: '100%',
      padding: '0 1rem',
    },
  },
  sliderDiv: {
    display: 'table-cell',
    marginLeft: 'auto',
    position: 'relative',
    height: '264px',
    '@media only screen and (max-width: 600px)': {
      display: 'block',
      height: '200px',
    },
  },
  sliderDivContainer: {
    height: 'calc(100% - 147px)',
  },
  leftAdArea: {
    minWidth: 300,
    maxWidth: 340,
    display: 'table-cell',
    marginLeft: 'auto',
    position: 'relative',
    borderTopLeftRadius: '4px',
    borderBottomLeftRadius: '4px',
    background: 'linear-gradient(135deg, #50A684 30%, #115E67 90%)',
    '@media only screen and (max-width: 600px)': {
      minWidth: '100%',
      maxWidth: '100%',
      display: 'block',
      borderTopLeftRadius: '4px',
      borderTopRightRadius: '4px',
      borderBottomLeftRadius: '0',
    },
  },
  chartIcon: {
    verticalAlign: 'middle',
    position: 'absolute',
    top: 0,
    bottom: 0,
    margin: 'auto',
    width: '130px !important',
    left: 0,
    right: 0,
    background: '#fafafa',
    borderRadius: '1px',
    '@media only screen and (max-width: 600px)': {
      width: '100px !important',
    },
  },
  leftAdAreaText: {
    color: '#fafafa',
    fontSize: 'larger',
    marginTop: '65px',
    borderRadius: '4px',
    '@media only screen and (max-width: 600px)': {
      fontSize: '1rem',
      marginTop: '2rem',
      padding: '0 1rem',
    },
  },
  mainContentArea: {
    marginRight: 'auto',
    marginLeft: 'auto',
    maxWidth: '95%',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '@media only screen and (max-width: 600px)': {
      maxWidth: '100%',
      padding: '0 0.5rem',
      maxHeight: 'calc(100vh - 120px)',
      overflowY: 'auto',
      alignItems: 'flex-start',
    },
  },
  loginContent: {
    marginRight: 'auto',
    marginLeft: 'auto',
    minWidth: 300,
    maxWidth: 340,
    textAlign: 'center',
    paddingBottom: '1rem',
    '@media only screen and (max-width: 600px)': {
      minWidth: '100%',
      maxWidth: '100%',
      padding: '0 1rem 1rem',
    },
  },
  instruction: {
    paddingBottom: 5,
    paddingLeft: '2%',
    paddingRight: '2%',
    '@media only screen and (max-width: 600px)': {
      fontSize: '0.875rem',
      paddingLeft: '1rem',
      paddingRight: '1rem',
    },
  },
  logoContainer: {
    paddingTop: '0%',
    paddingBottom: '5%',
    textAlign: 'center',
    color: theme.palette.text.secondary,
    '@media only screen and (max-width: 600px)': {
      paddingTop: '1rem',
      paddingBottom: '2rem',
    },
  },
  footer: {
    display: 'grid',
    placeItems: 'center',
    gridTemplateColumns: '0.1fr 1fr',
    textAlign: 'center',
    alignItems: 'center',
    position: 'fixed',
    width: '50%',
    zIndex: '9999',
    bottom: 15,
    fontSize: '0.9rem',
    fontWeight: '100',
    '@media only screen and (max-width: 960px)': {
      width: '100%',
      position: 'relative',
      bottom: 'auto',
      padding: '1rem',
      gridTemplateColumns: '1fr',
      gap: '0.5rem',
    },
  },
  rightmaincontent: {
    height: '100vh',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    backgroundColor: '#EFF7FA',
    padding: '15px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    '@media only screen and (max-width: 960px)': {
      height: 'auto',
      minHeight: '100vh',
      padding: '1rem',
    },
  },
  righthead: {
    height: '35%',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    backgroundColor: 'rgb(252,108,63)',
  },
  rightTitle: {
    fontSize: '80px',
    color: 'rgb(255,255,255)',
    textAlign: 'center',
    padding: '30px',
  },
  rightsubtext: {
    fontSize: '35px',
    color: 'rgb(255,255,255)',
    paddingLeft: '135px',
  },
  rightcontent: {
    height: '65%',
    textAlign: 'center',
    backgroundImage: `url(${mainunit})`,
    backgroundSize: '100% 100%',
    backgroundRepeat: 'no-repeat',
    backgroundColor: 'rgb(252,108,63)',
    marginTop: '-35px',
  },
  rightimg: {
    width: '100%',
    height: '630px',
  },
  hideForCorporateLogin: {
    display: 'none !important',
  },
  showForCorporateLogin: {
    display: 'inherit !important',
  },
  secureBadgeTitle: {
    paddingBottom: 2,
    paddingLeft: '2%',
    paddingRight: '2%',
  },
  invisibleInput: {
    position: 'absolute',
    opacity: 0,
    height: 0,
    pointerEvent: 'none',
  },
  brandLogoSize2: {
    objectFit: 'contain',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'block',
    paddingTop: 12,

    /* Extra small devices (phones, 600px and down) */
    '@media only screen and (max-width: 600px)': {
      width: '40%',
    },

    /* Small devices (portrait tablets and large phones, 600px and up) */
    '@media only screen and (min-width: 600px)': {
      width: '70%',
    },

    /* Medium devices (landscape tablets, 768px and up) */
    '@media only screen and (min-width: 768px)': {
      width: '50%',
    },

    /* Large devices (laptops/desktops, 992px and up) */
    '@media only screen and (min-width: 992px)': {
      width: '40%',
    },

    /* Extra large devices (large laptops and desktops, 1200px and up) */
    '@media only screen and (min-width: 1200px)': {
      width: '30%',
    },

    '@media only screen and (max-height: 520px)': {
      width: '12%',
    },
  },
  signInButton: {
    height: '55px',
    width: '45%',
    background: 'linear-gradient(135deg, #50A684 30%, #115E67 90%)',
    color: 'white',
    '@media only screen and (max-width: 600px)': {
      width: '48%',
      height: '48px',
      fontSize: '0.875rem',
    },
  },
  oktaFormContainer: {
    marginTop: '2rem',
  },
  oktaFormControl: {
    paddingTop: 5,
    paddingBottom: '3rem',
  },
  oktaButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },
  startButtonIcon: {
    fontSize: '30px !important',
  },
  pingButton: {
    background: '#b3282d',
    height: '55px',
    width: '95%',
    padding: '1.5rem',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      background: '#b3282d',
    },
    '@media only screen and (max-width: 600px)': {
      width: '100%',
      height: '48px',
      padding: '1rem',
      fontSize: '0.875rem',
    },
  },
  pingContinueButton: {
    background: '#b3282d',
    height: '55px',
    width: '45%',
    '&:hover': {
      background: '#b3282d',
    },
  },
  oktaContinueButton: {
    background: '#007dc1',
    height: '55px',
    width: '45%',
    padding: '1.5rem',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      background: '#007dc1',
    },
  },
  oktaButton: {
    background: '#007dc1',
    height: '55px',
    width: '95%',
    padding: '1.5rem',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      background: '#007dc1',
    },
    '@media only screen and (max-width: 600px)': {
      width: '100%',
      height: '48px',
      padding: '1rem',
      fontSize: '0.875rem',
    },
  },
  oktaBackArrow: {
    marginLeft: '-5px',
    marginRight: '5px',
  },
  oktaCircle: {
    border: '6px solid white',
    borderRadius: '50%',
    height: '25px',
    width: '25px',
    marginLeft: '-10px',
    marginRight: '10px',
    '&:hover': {
      border: '6px solid black',
      borderRadius: '50%',
    },
  },
  kaktusLogo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  kaktusBottom: {
    textAlign: 'center',
    alignItems: 'center',
    position: 'fixed',
    bottom: '0',
    fontSize: '0.9rem',
    fontWeight: '100',
    width: '50%',
    marginBottom: '-1%',
    '@media only screen and (max-width: 960px)': {
      width: '100%',
      position: 'relative',
      bottom: 'auto',
      marginBottom: '0',
      padding: '1rem',
    },
  },
  LearnHowTo: {
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontSize: '24px',
    color: '#6C7B92',
    textAlign: 'center',
    fontWeight: 600,
    '@media only screen and (max-width: 600px)': {
      fontSize: '18px',
      padding: '0 1rem',
    },
  },
  hithLightedFont: {
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontSize: '24px',
    color: '#00A7E0',
    fontWeight: 600,
    '@media only screen and (max-width: 600px)': {
      fontSize: '18px',
    },
  },
  sectionContainer: {
    width: '90%',
    '@media only screen and (max-width: 600px)': {
      width: '100%',
    },
  },
  kaktusConciergeSection: {
    width: '100%',
  },
  BrandInfo: {
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontSize: '18px',
    color: '#6C7B92',
    '@media only screen and (max-width: 600px)': {
      fontSize: '14px',
    },
  },
  didYouKnow: {
    fontSize: '26px',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontWeight: 900,
    margin: 0,
    color: '#00A7E0',
    '@media only screen and (max-width: 600px)': {
      fontSize: '20px',
    },
  },
  isILocaBox: {
    margin: 0,
    fontSize: '18px',
    fontWeight: 500,
    color: 'gray',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    '@media only screen and (max-width: 600px)': {
      fontSize: '14px',
    },
  },
  iBrandInfo: {
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontSize: '18px',
    color: '#6C7B92',
    fontWeight: 700,
    textAlign: 'center',
    '@media only screen and (max-width: 600px)': {
      fontSize: '14px',
    },
  },
  inputLabel: {
    marginLeft: '-14px',
  },
  diagnostics_dialogbox: {
    '& .MuiPaper-root': {
      maxWidth: '100% !important',
      width: '100% !important',
      height: '100% !important',
      '& .container': {
        width: 'inherit',
        height: 'inherit',
        '& iframe': {
          width: 'inherit',
          height: 'inherit',
        },
      },
    },
    '& .MuiDialogTitle-root': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  },
  pickupCodeInput: {
    margin: '0 15px 0 0',
    maxHeight: '50px',
    width: '50px',
    fontSize: '50px',
    border: '1px solid #305598',
    borderRadius: '8px',
    textAlign: 'center',
    outline: 'none',
    textTransform: 'uppercase',
    // caretColor: 'transparent',
    '&::placeholder': {
      color: 'lightgray',
    },
  },
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 92px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none',
  },
  clearButton: {
    display: 'flex',
    margin: '10px',
    paddingLeft: '30px',
  },
  didYouKnowImages: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: '33.3333%',
    '& img': {
      width: '40%'
    }
  }
});

Amplify.configure({
  Auth: {
    // REQUIRED - Amazon Cognito Identity Pool ID
    // identityPoolId: 'us-east-1:16c7cd5e-52d1-442d-af74-235153fea56d',
    // REQUIRED - Amazon Cognito Region
    region: process.env.REACT_APP_CG_REGION,
    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: process.env.REACT_APP_CG_USERPOOLID,
    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: process.env.REACT_APP_CG_WEBCLIENTID,
    // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
    // mandatorySignIn: true,
    // // OPTIONAL - Configuration for cookie storage
    //     cookieStorage: {
    //     // REQUIRED - Cookie domain (only required if cookieStorage is provided)
    //         domain: '.yourdomain.com',
    //     // OPTIONAL - Cookie path
    //         path: '/',
    //     // OPTIONAL - Cookie expiration in days
    //         expires: 365,
    //     // OPTIONAL - Cookie secure flag
    //         secure: true
    //     }
  },
});

// Auth.currentAuthenticatedUser()

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const tz = moment().tz(timeZone);
const findOffset = tz.utcOffset();
let string = '';
if (String(findOffset).startsWith('-')) {
  string = `- ${String(findOffset).slice(1)}`;
} else string = `+ ${String(findOffset)}`;
const zone = `(UTC ${string}) ${timeZone}`;

class Login extends Component {
  static contextType = MultiTabContext;
  
  constructor(props) {
    super(props);
    const { t } = props
    
    this.state = {
      username: '',
      password: '',
      instruction: `${t("Login.Instruction")}`,
      usernameError: false,
      passwordError: false,
      nameError: false,
      user: null,
      forgotPasswordFlow: false,
      forgotPasswordSMSFlow: false,
      userid: '',
      isCorporateLogin: false,
      ButtonAction: 0,
      Data: {},
      mfa: false,
      mfaString: '',
      otp: '',
      isSubmitDisabled: false,
      loader: false,
      otpError: '',
      otpSuccess: '',
      otpSent: false,
      isSecureBadgeLogin: false,
      secureBadgeErrorMessage: '',
    };
    this.loginType = '';
  }

  componentDidMount() {
    let n = sessionStorage.length;
    let l = localStorage.length;
  
    // Retrieve and preserve specific keys before clearing
    const currentLang = localStorage.getItem('i18nextLng') || 'en';
    const emailDomain = localStorage.getItem('emailDomain');
    const discoveryUrl = localStorage.getItem('discoveryUrl');
    const browserTestDoNotAskMeAgain = localStorage.getItem('browserTestDoNotAskMeAgain');
  
    // Clear all localStorage keys
    while (l--) {
      let keyl = localStorage.key(l);
      if (keyl) {
        // Preserve audio device preferences and browser fingerprint across sessions
        if (
          ![
            "selectedConsultRingingDevice",
            "selectedConsultCallingDevice",
            "selectedConsultMicInput",
            "selectedConsultCamera",
            "preferredConsultRingingDevice",
            "preferredConsultCallingDevice",
            "preferredConsultMicInput",
            "preferredConsultCamera",
            "portalBrowserFingerprint",
            "portalBrowserDetails",
          ].includes(keyl)
        ) {
          localStorage.removeItem(keyl);
        }
      }
    }
  
    // Clear all sessionStorage keys
    while (n--) {
      let key = sessionStorage.key(n);
      if (key) {
        sessionStorage.removeItem(key);
      }
    }
  
    // Restore preserved keys
    localStorage.setItem('i18nextLng', currentLang);
    if (discoveryUrl) {
      localStorage.setItem('discoveryUrl', discoveryUrl);
    }
    if (emailDomain) localStorage.setItem('emailDomain', emailDomain);

    if (browserTestDoNotAskMeAgain){
      localStorage.setItem('browserTestDoNotAskMeAgain', browserTestDoNotAskMeAgain);
    }
    
    if (this.props.location.hash === '#/ping/login') {
      this.pingOIDCLogin();
      return;
    } 
    serviceWorker.unregister();
    const urlHash = window.location.hash;
    if(![undefined, 'undefined', null, 'null', ""].includes(urlHash)) {
      const encryptedText = urlHash.substring(1, urlHash.length);
      if (![undefined, "undefined", "null", null, ""].includes(encryptedText)) {
        localStorage.setItem("wasRedirected", true);
        this.handleDecrypt(encryptedText);
        setTimeout(() => {
          this.signIn(null);
        }, 1000);
      }
    }
  }

  componentWillUnmount() {
  }
  
  updateUsername = (e) => {
    this.setState({ username: e.target.value });
  };
  updateName = (e) => {
    this.setState({ name: e.target.value });
  };
  updateNewPassword = (e) => {
    this.setState({ newPassword: e.target.value });
  };
  updateSMSCode = (e) => {
    this.setState({ smsCode: e.target.value });
  };
  updateResetNewPassword = (e) => {
    this.setState({ resetNewPassword: e.target.value });
  };
  updateResetConfirmPassword = (e) => {
    this.setState({ resetConfirmPassword: e.target.value });
  };
  updateConfirmPassword = (e) => {
    this.setState({ confirmPassword: e.target.value });
  };
  updatePassword = (e) => {
    this.setState({ password: e.target.value });
  };
  signUp = (e) => {
    e.preventDefault();
    if (
      this.state.name &&
      this.state.newPassword &&
      this.state.confirmPassword &&
      this.state.newPassword === this.state.confirmPassword
    ) {
      Auth.completeNewPassword(this.state.user, this.state.newPassword, {
        name: this.state.name,
      })
        .then((data) => {
          this.setState({
            nameError: false,
            newPasswordError: false,
            confirmPasswordError: false,
          });
          let userObj = {
            username: this.state.username,
          };
          fetch(process.env.REACT_APP_BASEURL + 'UpdateResetPWDate', {
            method: 'post',
            withCredentials: true,
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(userObj),
          });
          this.state.user && window.location.reload(true);
          Auth.signIn(this.state.username, this.state.newPassword)
            .then((updatedUser) => {
              const { t } = this.props;
              this.setState({
                instruction: t("Login.Welcome"),
                usernameError: false,
                passwordError: false,
              });
              sessionStorage.setItem('user', JSON.stringify(updatedUser));
              fetch(
                process.env.REACT_APP_BASEURL + 'getPermissionsAfterSignUp',
                {
                  method: 'POST',
                  withCredentials: true,
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization:
                      'Bearer ' +
                      JSON.parse(sessionStorage.getItem('user'))
                        .signInUserSession.idToken.jwtToken,
                  },
                  body: JSON.stringify(userObj),
                }
              )
                .then((response) => response.json())
                .then((Permissons) => {
                  if (Permissons.permission) {
                    sessionStorage.setItem(
                      'permissions',
                      JSON.stringify(Permissons.permission)
                    );
                  }
                  if (Permissons.user) {
                    let roles;
                    if (Permissons.user.roles.length > 0) {
                      sessionStorage.setItem(
                        'permissionUser',
                        JSON.stringify(Permissons.user.roles[0].id)
                      );
                      roles = Permissons.user.roles;
                      roles.forEach((element) => {
                        if (element.id === USER_ROLES.PHARMACIST) {
                          sessionStorage.setItem(
                            'roleId',
                            JSON.stringify(element.id)
                          );
                        }
                        if (element.id === USER_ROLES.ADMIN) {
                          sessionStorage.setItem(
                            'admin',
                            JSON.stringify(element.id)
                          );
                        }
                        if (element.id === USER_ROLES.SUPERADMIN) {
                          sessionStorage.setItem(
                            'superadmin',
                            JSON.stringify(element.id)
                          );
                        }
                        if (element.id === USER_ROLES.DELIVERYTECH) {
                          sessionStorage.setItem(
                            'deliverytech',
                            JSON.stringify(element.id)
                          );
                        }
                      });
                    }
                  }
                  sessionStorage.setItem('user', JSON.stringify(updatedUser));
                  
                  /* audit trail entry for user login. */
                  writeAuditLog(`User logged in to connect.`, 'Login');
                  
                  // Set up token expiry handler for auto-logout
                  setupTokenExpiryHandler(updatedUser, { loginMethod: 'STANDARD' });
                  
                  this.handleNavigateByGroupType()
                });
            })
            .catch((error) => console.error(error));
        })
        .catch((error) => {
          this.setState({
            instruction: error.message + '',
            newPasswordError: false,
            confirmPasswordError: false,
          });
        });
    } else if (!this.state.name) {
      this.setState({ nameError: true });
    } else if (!this.state.newPassword) {
      this.setState({ newPasswordError: true });
    } else if (!this.state.confirmPassword) {
      this.setState({ confirmPasswordError: true });
    } else if (this.state.newPassword !== this.state.confirmPassword) {
      const { t } = this.props;
      this.setState({
        instruction: t("Login.PassDoNotMatch"),
        nameError: false,
        newPasswordError: true,
        confirmPasswordError: true,
      });
    }
  };
  forgotPassword = (e) => {
    const { t } = this.props;
    if (!this.state.username) {
      this.setState({
        instruction: t("Login.PassDoNotMatch"),
        usernameError: true,
        passwordError: false,
      });
    } else {
      Auth.forgotPassword(this.state.username)
        .then((data) => {
          if (data.CodeDeliveryDetails.DeliveryMedium === 'SMS') {
            const message = `${t("Login.VerificationCodeSent")} ${data.CodeDeliveryDetails.Destination}`;
            this.setState({
              instruction: message,
              usernameError: false,
              passwordError: false,
              forgotPasswordSMSFlow: true,
            });
          } else {
            const message = t("Login.VerificationEmailSent")
            this.setState({
              instruction: message,
              usernameError: false,
              passwordError: false,
              forgotPasswordSMSFlow: true,
            });
          }
          let userObj = {
            username: this.state.username,
          };
          fetch(process.env.REACT_APP_BASEURL + 'getresetpwdatefromuser', {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(userObj),
          })
            .then((response) => {
              try {
                return response.text();
              } catch (error) {
                return null;
              }
            })
            .then((uData) => {
              let Data = JSON.parse(uData);
              let invalidValues = [undefined, null, '', 'undefined', 'null'];
              function isInvalid(value) {
                return invalidValues.indexOf(value) !== -1;
              }
              function getUserId(data) {
                if (isInvalid(data)) return '';
                if (Array.isArray(data)) {
                  var idFromArray = data && data[0] && data[0].id;
                  return isInvalid(idFromArray) ? '' : idFromArray;
                }
                if (typeof data === 'object') {
                  var idFromObject = data && data.id;
                  return isInvalid(idFromObject) ? '' : idFromObject;
                }
                return '';
              }
              this.setState({ userid: getUserId(Data) });
            });
        })
        .catch((err) =>
          this.setState({
            instruction: err.message,
            usernameError: false,
            passwordError: false,
          })
        );
    }
  };
  forgotPasswordSubmit = (e) => {
    const { t } = this.props;
    e.preventDefault();
    if (
      this.state.username &&
      this.state.smsCode &&
      this.state.resetNewPassword &&
      this.state.resetConfirmPassword &&
      this.state.resetNewPassword === this.state.resetConfirmPassword
    ) {
      if (!this.state.userid) {
        this.setState({
          instruction: t("Login.SomethingWentWrong"),
          resetNewPasswordError: true,
          resetConfirmPasswordError: true,
        });
        return;
      }
      let sha256 = require('js-sha256');
      let pw_hash = sha256(
        `${this.state.resetNewPassword} ${this.state.userid}`
      );
      let passwordObj = {
        id: this.state.userid,
        password: pw_hash,
      };
      fetch(process.env.REACT_APP_BASEURL + 'getLastPasswords', {
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(passwordObj),
      })
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            return null;
          }
        })
        .then((passwordmatch) => {
          let is_password_match = JSON.parse(passwordmatch);
          if (
            is_password_match.res === true ||
            is_password_match.res === 'true'
          ) {
            this.setState({
              instruction: t("Login.PasswordAlreadyExist"),
              nameError: false,
              resetNewPasswordError: true,
              resetConfirmPasswordError: true,
            });
          } else {
            Auth.forgotPasswordSubmit(
              this.state.username,
              this.state.smsCode,
              this.state.resetNewPassword
            )
              .then((data) => {
                this.setState({
                  instruction: t("Login.PasswordResetSuccess"),
                  forgotPasswordSMSFlow: false,
                });
                let pw_obj = {
                  userid: this.state.userid,
                  password: pw_hash,
                };
                fetch(process.env.REACT_APP_BASEURL + 'savepassword', {
                  method: 'post',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(pw_obj),
                })
                  .then((response) => {
                    try {
                      return response.text();
                    } catch (error) {
                      return null;
                    }
                  })
                  .then((uData) => { });
                let userObj = {
                  username: this.state.username,
                };
                fetch(process.env.REACT_APP_BASEURL + 'UpdateResetPWDate', {
                  method: 'post',
                  withCredentials: true,
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(userObj),
                })
                  .then((response) => {
                    try {
                      return response.text();
                    } catch (error) {
                      return null;
                    }
                  })
                  .then((uData) => { });
              })
              .catch((err) => console.error(err));
          }
        });
    } else if (!this.state.smsCode) {
      this.setState({ smsCodeError: true });
    } else if (!this.state.resetNewPassword) {
      this.setState({ resetNewPasswordError: true });
    } else if (!this.state.resetConfirmPassword) {
      this.setState({ resetConfirmPasswordError: true });
    } else if (
      this.state.resetNewPassword !== this.state.resetConfirmPassword
    ) {
      this.setState({
        instruction: t("Login.PassDoNotMatch"),
        nameError: false,
        resetNewPasswordError: true,
        resetConfirmPasswordError: true,
      });
    }
  };

  afterSignInHandler = async () => {
    // Update Last Login Date Time || TASK DI-748
    let userObj = {
      username: this.state.username,
    };
    await fetch(process.env.REACT_APP_BASEURL + 'UpdateLastLoginDateTime', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(userObj),
    })
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then(async (uData) => {
        const parsedUserObject = JSON.parse(uData);
        const name =
          parsedUserObject &&
          parsedUserObject.res &&
          parsedUserObject.res.parentAccount &&
          parsedUserObject.res.parentAccount.parentAccount &&
          parsedUserObject.res.parentAccount.parentAccount.name;
        const group =
          parsedUserObject &&
          parsedUserObject.res &&
          parsedUserObject.res.group
        const {
          res: { preferred_language },
        } = parsedUserObject;
        if (preferred_language) {
          sessionStorage.setItem('preferredLanguage', preferred_language);
          this.changeLanguageKey(preferred_language);
        }
        if(![undefined, 'undefined', null, 'null', ""].includes(group)) {
          sessionStorage.setItem("groupName", group.name)
          sessionStorage.setItem("groupID", group.id)
          sessionStorage.setItem("groupType", group.type_id)
        } else {
          sessionStorage.setItem("groupName", "");
          sessionStorage.setItem("groupID", "");
          sessionStorage.setItem("groupType", "");
        }
        if (name) {
          sessionStorage.setItem(
            'parentAccountName',
            JSON.parse(uData).res.parentAccount.parentAccount.name
          );
          sessionStorage.setItem(
            'parentAccountId',
            JSON.parse(uData).res.parentAccount.parentAccount.id
          );
          sessionStorage.setItem(
            'timeZone',
            JSON.parse(uData).res.parentAccount.parentAccount.timezone
              ? JSON.parse(uData).res.parentAccount.parentAccount.timezone
              : zone
          );
          persistAutoLogoutAccountSetting(
            JSON.parse(uData).res.parentAccount.parentAccount
          );
        } else {
          sessionStorage.setItem('parentAccountName', '');
          sessionStorage.setItem('parentAccountId', '');
          sessionStorage.setItem('timeZone', '');
          sessionStorage.setItem("groupName", "");
          sessionStorage.setItem("groupID", "");
          sessionStorage.setItem("groupType", "");
          persistAutoLogoutAccountSetting(false);
        }
      });
    //Get Permissions for Login user
    await fetch(process.env.REACT_APP_BASEURL + 'getRolesPermissions', {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((Permissons) => {
        this.setState({
          loader: false,
        });
        const permissionData = Permissons && Permissons.permission
        const pharmacyPermissions = permissionData.filter(p => ![ROLES_TYPE.RetailAdmin, ROLES_TYPE.RetailTechnician].includes(p.role_id));
        if (pharmacyPermissions) {
          sessionStorage.setItem(
            'permissions',
            JSON.stringify(pharmacyPermissions)
          );
        }
        if (Permissons.user) {

          if (Permissons.user.first_name || Permissons.user.last_name) {
            sessionStorage.setItem('user.firstname', Permissons.user.first_name);
            sessionStorage.setItem('user.lastname', Permissons.user.last_name);
          }
          else {
            sessionStorage.setItem('user.firstname', Permissons.user.name);
          }

          let roles;
          if (Permissons.user.roles.length > 0) {
            sessionStorage.setItem(
              'permissionUser',
              JSON.stringify(Permissons.user.roles[0].id)
            );
            roles = Permissons.user.roles;
            roles.forEach((element) => {
              if (element.id === USER_ROLES.PHARMACIST) {
                sessionStorage.setItem('roleId', JSON.stringify(element.id));
              }
              if (element.id === USER_ROLES.ADMIN) {
                sessionStorage.setItem('admin', JSON.stringify(element.id));
              }
              if (element.id === USER_ROLES.SUPERADMIN) {
                sessionStorage.setItem(
                  'superadmin',
                  JSON.stringify(element.id)
                );
              }
              if (element.id === USER_ROLES.DELIVERYTECH) {
                sessionStorage.setItem(
                  'deliverytech',
                  JSON.stringify(element.id)
                );
              }
            });
          }
        }
        this.getPreferredLocation();
      });
  };

  signIn = (e) => {
    const { t } = this.props;
    if (this.state.forgotPasswordSMSFlow) {
    } else if (this.state.forgotPasswordFlow) {
    } else {
      e && e.preventDefault();
      let userObj = {
        username: this.state.username,
      };
      let is_mfa_required = false;
      this.setState({
        loader: true,
        instruction: t("Login.VerifyingUser"),
        otpSuccess: '',
        otp: '',
        otpError: '',
      });
      fetch(process.env.REACT_APP_BASEURL + 'getresetpwdatefromuser', {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(userObj),
      })
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            return null;
          }
        })
        .then((uData) => {
          let Data = JSON.parse(uData);
          if (!Data) {
            this.setState({
              instruction: t("Login.InvalidUnamePass"),
              usernameError: true,
              passwordError: true,
              loader: false,
            });
            return;
          } else {
            if (Data.message) {
              this.setState({
                instruction: t("Login.SomethingWentWrong"),
                usernameError: true,
                passwordError: true,
                loader: false,
              });
              return;
            }
            if (Data && Data[0] && Data[0].is_enabled === false) {
              this.setState({
                instruction:
                  t("Login.AccountDisabled"),
                usernameError: false,
                passwordError: false,
                loader: false,
              });
              return;
            }
            Data.is_mfa_required && (is_mfa_required = true);
            this.setState({
              userid: Data.id,
              otpSent: true,
              otpSuccess: this.state.otpSent ? t("Login.NewOTPSent") : '',
            });
            const passwordExpiry = new Date(Data.password_reset_on);
            passwordExpiry.setDate(passwordExpiry.getDay() + 180);
            if (passwordExpiry <= Date.now()) {
              Auth.forgotPassword(this.state.username).then((data) => {
                if (data.CodeDeliveryDetails.DeliveryMedium === 'SMS') {
                  const message = `${t(Login.VerificationCodeSent)} ${data.CodeDeliveryDetails.Destination}`;
                  this.setState({
                    instruction: message,
                    usernameError: false,
                    passwordError: false,
                    forgotPasswordSMSFlow: true,
                    loader: false,
                  });
                } else {
                  this.setState({
                    instruction: t("Login.PasswordExpired"),
                    usernameError: false,
                    passwordError: false,
                    forgotPasswordSMSFlow: true,
                    loader: false,
                  });
                }
              }).catch((error) => {
                if(error && error.message && error.message === ErrorMessages.InfiniteState) {
                  this.setState({
                    instruction: t("Login.LockedAccount"),
                    usernameError: false,
                    passwordError: false,
                    loader: false,
                  });
                } else {
                  this.setState({
                    instruction: error.message,
                    usernameError: false,
                    passwordError: false,
                    loader: false,
                  });
                }
              });
            } else {
              Auth.signIn(this.state.username, this.state.password)
                .then(async (user) => {
                  const { t } = this.props;
                  this.setState({
                    instruction: t("Login.Welcome"),
                    usernameError: false,
                    passwordError: false,
                    loader: false,
                  });
                  if (
                    user.challengeName === 'NEW_PASSWORD_REQUIRED' ||
                    user.challengeName === 'PASSWORD_VERIFIER'
                  ) {
                    this.setState({
                      instruction: t("Login.WelcomeConfirmIdentity"),
                      usernameError: false,
                      passwordError: false,
                      loader: false,
                    });
                    this.setState({
                      user: user,
                      name: user.challengeParam.userAttributes.name,
                      loader: false,
                      userEmail: this.state.username
                    });
                  } else {
                    sessionStorage.setItem('user', JSON.stringify(user));
                    /* 
                      Check if Logged in user belongs to retail's type of account or not. 
                      If User is ilocalbox user then, it will allow to select the type retail 
                      in Manage Accounts or it will be disabled for other vendors.
                    */
                    const _checkIfUserBelogsToILocalBox = await this.checkIfUserBelogsToILocalBox();
                    const _userAccount = _checkIfUserBelogsToILocalBox && _checkIfUserBelogsToILocalBox[0] && _checkIfUserBelogsToILocalBox[0].parentAccount;
                    const _loggedInUserName = _checkIfUserBelogsToILocalBox && _checkIfUserBelogsToILocalBox[0] && _checkIfUserBelogsToILocalBox[0].username;
                    if(_loggedInUserName.includes('ilocalbox.com')) {
                      localStorage.setItem('isIlocalUser', true);
                    } else {
                      localStorage.setItem('isIlocalUser', false);
                    }
                    if(_userAccount.type_id === AccountsTypeEnum.Retailer) {
                      localStorage.setItem('isRetail', true);
                    } else {
                      localStorage.setItem('isRetail', false);
                    }
                    is_mfa_required
                      ? this.setState({ mfa: true })
                      : await this.afterSignInHandler();
                  }
                  /* audit trail entry for user login. */
                  sessionStorage.setItem('loginMethod', 'STANDARD');
                  await writeAuditLog(`User logged in to connect.`, 'Login', {}, {}, { deferMs: 0, wait: true });
                  
                  // Set up token expiry handler for auto-logout
                  setupTokenExpiryHandler(user, { loginMethod: 'STANDARD' });
                  
                  // Check for browser setting changes after 1 minute (allows time for permission prompts)
                  checkBrowserDetailsAfterLogin(60000);
                })
                .catch((err) => {
                  switch (err.code) {
                    case 'UserNotFoundException':
                      this.setState({
                        instruction: err.message,
                        usernameError: true,
                        loader: false,
                      });
                      break;
                    case "NotAuthorizedException":
                      if(err && err.message && err.message === ErrorMessages.TemporaryExpired) {
                        this.setState({
                          instruction: t("Login.LockedAccount"),
                          usernameError: false,
                          passwordError: false,
                          loader: false,
                        });
                      } else {
                        this.setState({
                          instruction: err.message,
                          usernameError: false,
                          passwordError: false,
                          loader: false,
                        });
                      }
                      break;
                    default:
                      this.setState({
                        instruction: t("Login.InvalidUnamePass"),
                        usernameError: true,
                        passwordError: true,
                        loader: false,
                      });
                  }
                });
            }
          }
        });
    }
  };

  handleCorporateLogin = (e, emailDomain) => {
    let username = this.state.username || emailDomain;
    if (username.indexOf('@') === -1) {
      username = 'username@' + username;
    }
    emailDomain = username.split('@')[1];
    localStorage.setItem('emailDomain', emailDomain);
    try {
      const { t } = this.props;
      e.preventDefault();
      if (username.length === 0) {
        this.setState({ usernameError: true });
      } else {
        this.setState({ usernameError: false });
        if (this.loginType === 'saml') {
          console.log('handleCorporateLogin for SAML');
          this.props.auth(username, null, null, this.loginType);
          return false;
        }
        fetch(
          process.env.REACT_APP_BASEURL + 'auth/oidc/' + username,
          {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
          }
        )
          .then((response) => response.json())
          .then((uData) => {
            if (uData.success) {
              this.setState({ instruction: t("Login.Welcome"), usernameError: false });
              const issuer = uData.issuer || uData.parentAccount.issuer;
              const clientId = uData.clientId || uData.parentAccount.client_id;
              const discoveryUrl = (uData.discoveryUrl !== undefined && uData.discoveryUrl !== null)
                  ? uData.discoveryUrl 
                  : (uData.parentAccount && uData.parentAccount.discovery_url) 
                      ? uData.parentAccount.discovery_url 
                      : null;
              sessionStorage.setItem('issuer', issuer);
              sessionStorage.setItem('clientId', clientId);
              if (discoveryUrl) {
                localStorage.setItem('discoveryUrl', discoveryUrl);
              }
              localStorage.setItem('isRetail', false); // If it is saml then do not consider it for Retail login for now.
              if (this.loginType === 'saml') {
                console.log('handleCorporateLogin for SAML');
                this.props.auth(
                  username,
                  null,
                  null,
                  this.loginType
                );
                return false;
              } else { // Non SAML Login
                this.props.auth(
                  username,
                  issuer,
                  clientId,
                  this.loginType,
                  null,
                  discoveryUrl
                );
              }
              /* audit trail entry for SSO user login is handled in App.js */
            } else {
              this.setState({
                instruction: uData.message,
                usernameError: true,
              });
            }
          })
          .catch((error) => {
            if (error && error.response) {
              console.log(error.response);
            }
          });
      }
    } catch (error) {
      return error;
    }
  };

  handleGoBack = () => {
    this.loginType = '';
    sessionStorage.removeItem('loginType');
    this.setState({
      isCorporateLogin: false,
      ButtonAction: 0,
      username: '',
      password: '',
      usernameError: false,
    });
  };

  oktaLogin = () => {
    this.loginType = 'okta';
    sessionStorage.setItem('loginType', this.loginType);
    this.setState({
      isCorporateLogin: true,
      // username: '',
      password: '',
      usernameError: false,
      passwordError: false,
    });
  };

  pingOIDCLogin = () => {
    this.loginType = 'pingOIDC';
    sessionStorage.setItem('loginType', this.loginType);
    this.setState({
      isCorporateLogin: true,
      // username: '',
      password: '',
      usernameError: false,
      passwordError: false,
    });
  };

  samlLogin = (e) => {
    this.loginType = 'saml';
    sessionStorage.setItem('loginType', this.loginType);
    const emailDomain = localStorage.getItem('emailDomain');
    if (emailDomain && emailDomain.length > 0) {
      this.handleCorporateLogin(e, emailDomain);
      return true;
    }
    this.setState({
      isCorporateLogin: true,
      // username: '',
      password: '',
      usernameError: false,
      passwordError: false,
    });
  };

  changeLanguageKey = (key) => {
    const { i18n } = this.props;
    i18n.changeLanguage(key);
  };

  onChangeInputEventEmitterHandler = (SelectedInput, input) => {
    let event = '';
    const value = parseInt(input.slice(-1), 10);
    document.querySelector('#' + SelectedInput).value = isFinite(value)
      ? value
      : '';
    event = new Event('change', { bubbles: true });
    event.simulated = true;
    document.querySelector('#' + SelectedInput).dispatchEvent(event);
    return event;
  };

  onChange = (input) => {
    if (document.querySelector('#otp0').value.length === 0) {
      let event = this.onChangeInputEventEmitterHandler('otp0', input);
      this.onChangeInputHandler(0, event);
    } else if (document.querySelector('#otp1').value.length === 0) {
      let event = this.onChangeInputEventEmitterHandler('otp1', input);
      this.onChangeInputHandler(1, event);
    } else if (document.querySelector('#otp2').value.length === 0) {
      let event = this.onChangeInputEventEmitterHandler('otp2', input);
      this.onChangeInputHandler(2, event);
    } else if (document.querySelector('#otp3').value.length === 0) {
      let event = this.onChangeInputEventEmitterHandler('otp3', input);
      this.onChangeInputHandler(3, event);
    } else if (document.querySelector('#otp4').value.length === 0) {
      let event = this.onChangeInputEventEmitterHandler('otp4', input);
      this.onChangeInputHandler(4, event);
    } else if (document.querySelector('#otp5').value.length === 0) {
      let event = this.onChangeInputEventEmitterHandler('otp5', input);
      this.onChangeInputHandler(5, event);
    }
  };

  onKeyPress = (i, e) => {
    let button = e.key;
    switch (button) {
      case 'Clear':
        this.onResetOTPInputs();
        break;
      case 'Backspace':
        const o1 = document.querySelector('#otp0'),
          o2 = document.querySelector('#otp1'),
          o3 = document.querySelector('#otp2'),
          o4 = document.querySelector('#otp3'),
          o5 = document.querySelector('#otp4'),
          o6 = document.querySelector('#otp5');

        if (o6 && o6.value !== '') {
          o6.value = '';
        } else if (o5 && o5.value !== '') {
          o5.value = '';
        } else if (o4 && o4.value !== '') {
          o4.value = '';
        } else if (o3 && o3.value !== '') {
          o3.value = '';
        } else if (o2 && o2.value !== '') {
          o2.value = '';
        } else if (o1 && o1.value !== '') {
          o1.value = '';
          setTimeout(() => {
            this.onFocusEventHandler('otp0');
          }, 100);
        } else {
          setTimeout(() => {
            this.onFocusEventHandler('otp0');
          }, 100);
        }
        this.onChange(button);
        // this.onChangeInputHandler(i, e);
        break;
      default:
        this.onChange(button);
        // this.onChangeInputHandler(i, e);
        break;
    }
  };

  onChangeInputHandler = (index, input) => {
    if (isFinite(input)) {
      this.onFocusEventHandler('otp' + --index);
    } else if (input.length === 1 && index < 5) {
      this.onFocusEventHandler('otp' + ++index);
    } else {
      this.onFocusEventHandler('otp' + index);
    }
    this.onChangeOTP();
  };

  onFocusEventHandler = (name) => {
    const el = document.querySelector('#' + name);
    el && el.focus();
  };

  handleVerifyOTP = async (otp) => {
    const { t } = this.props;
    fetch(process.env.REACT_APP_BASEURL + 'saml/otp/verify/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: this.state.username,
        otp,
      }),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          console.log(error);
          return null;
        }
      })
      .then(async (res) => {
        if (res.success === false) {
          this.setState({
            otpError: res.message,
            otpSuccess: '',
            loader: false,
          });
          return;
        } else {
          this.setState({
            otpSuccess: t("Login.UserVerifiedRedirection"),
            otpError: '',
          });
          await this.afterSignInHandler();
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          otpError: error.message,
          otpSuccess: '',
          loader: false,
        });
      });
  };

  onChangeOTP = () => {
    let input = '';
    for (let i = 0; i <= 5; i++) {
      const value = document.querySelector('#otp' + i).value;
      input += value;
    }
    this.setState({ isSubmitDisabled: input.length === 6, otp: input });
    if (input.length === 6) {
      this.setState({ loader: true });
      let event = new Event('change', { bubbles: true });
      event.simulated = true;
      document.querySelector('#otp5').dispatchEvent(event);
      this.handleVerifyOTP(input);
    }
    const el = document.querySelector('#otp');
    if (el) {
      el.value = input;
      let event = new Event('onChange', { bubbles: true });
      event.simulated = true;
      el.dispatchEvent(event);
    }
  };

  onResetOTPInputs = () => {
    for (let i = 0; i <= 5; i++) {
      document.querySelector('#otp' + i).value = '';
    }
    this.setState({
      isSubmitDisabled: false,
      otp: '',
      otpError: '',
      otpSuccess: '',
    });
    this.onFocusEventHandler('otp0');
  };

  checkIfUserBelogsToILocalBox = async () => {
    return await fetch(
      process.env.REACT_APP_BASEURL +
      'users/' +
      JSON.parse(sessionStorage.getItem('user')).username,
      {
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    ).then((response) => {
      try {
        return response.json();
      } catch (error) {
        return null;
      }
    }).then((userData) => {
      return userData;
    }).catch((error) => {
      console.log(`Error while fetching user details ${error.message}`)
      return error.message;
    })
  }
 

  getPreferredLocation = () => {
    this.setState({ isInProgress: true });
    const loggedInUser = sessionStorage.getItem('user');
    if(![undefined, 'undefined', null, 'null', ''].includes(loggedInUser)) {
      const parsedUser = JSON.parse(loggedInUser);
      fetch(process.env.REACT_APP_BASEURL + `get/${parsedUser.username}/preferred/location`, {
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        }
      })
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            return null;
          }
        })
        .then((uData) => {
          if(![undefined, undefined, null, null, ''].includes(uData)) {
            const locationData = JSON.parse(uData);
            localStorage.setItem('selectedLocation', locationData.selected_location_id);
            localStorage.setItem('selectedLocationTypeId', locationData.selected_location_type_id)
            localStorage.setItem('selected_location_name', locationData.selected_location_name)
          } else {
            localStorage.setItem('selectedLocation', '');
            localStorage.setItem('selectedLocationTypeId', '')
            localStorage.setItem('selected_location_name', '')
          }
          this.handleNavigateByGroupType()
        }).catch((error) => {
          this.setState({ isInProgress: false })
        })
    }
  }

  handleNavigateByGroupType = () => {
    const userGroupTypeId = sessionStorage.getItem('groupType');
    if(![undefined, 'undefined', null, 'null', ""].includes(userGroupTypeId)) {
      switch(userGroupTypeId) {
        case GroupTypes.Pharmacy:
          navigate(`/home`);
          break;
        case GroupTypes.Retail:
        case GroupTypes.eCommerce:
        case GroupTypes.Audiology:
        case GroupTypes.Super:
          const uri = this.handleEncryption();
          if(![undefined, 'undefined', null, 'null', ""].includes(uri)) {
            window.location.href = `${process.env.REACT_APP_RETAIL_URL}#${uri}`;
          } else {
            navigate(`/home`);
          }
          break;
      default:
        break;
      }
    } else {
      navigate(`/home`);
    }
  }

  handleEncryption = () => {
    let ciphertext = null;
    try {
      const { username, password } = this.state;
      const stringToEnctypt = `${username},${password}`;
      ciphertext = CryptoJS.AES.encrypt(stringToEnctypt, process.env.REACT_APP_RETAIL_ENC_KEY).toString();
      return encodeURIComponent(ciphertext);
    } catch(error) {
      ciphertext = null;
    }
    return ciphertext;
  }

  handleDecrypt = (encryptedText) => {
    try {
      const decodedCiphertext = decodeURIComponent(encryptedText);
      const bytes = CryptoJS.AES.decrypt(
        decodedCiphertext,
        process.env.REACT_APP_RETAIL_ENC_KEY
      );
      const originalText = bytes.toString(CryptoJS.enc.Utf8);
      if (![undefined, "undefined", null, "null", ""].includes(originalText)) {
        const splitIDPass = originalText.split(",");
        let usernameEvent = {
          target: {
            value: splitIDPass[0]
          }
        }
        let passwordEvent = {
          target: {
            value: splitIDPass[0]
          }
        }
        this.updateUsername(usernameEvent);
        this.updatePassword(passwordEvent);
        this.setState({ username: splitIDPass[0], password: splitIDPass[1] })
        this.forceUpdate();
      }
    } catch (error) {
      console.log(error);
    }
  };

  handleSecureBadgeLogin = async () => {
    try {
      this.setState({ loader: true, secureBadgeErrorMessage: '' })
      const response = await fetch(`${process.env.REACT_APP_BASEURL}authenticateSecureBadge`, {
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ secret: this.state.encryptedCode }),
      });

      const res = await response.json();
      console.log('Login success res:', res);

      if (res && res.success) {
        const responseData = res.data;
        const jwtPayload = responseData.signInUserSession.idToken.payload;
        // Guest-without-email can have blank username; never leave state empty —
        // afterSignInHandler posts username to UpdateLastLoginDateTime which used
        // to resolve the wrong account via .where('username','').first().
        const username =
          (jwtPayload['username'] && String(jwtPayload['username']).trim()) ||
          (responseData.username && String(responseData.username).trim()) ||
          (jwtPayload['sub'] && String(jwtPayload['sub']).trim()) ||
          '';
        this.setState({ username })
        sessionStorage.setItem('user', JSON.stringify({
          ...responseData,
          username: username || responseData.username,
        }));
        
        // Set up token expiry handler for auto-logout
        setupTokenExpiryHandler(responseData, { loginMethod: 'SECURE_BADGE' });
        
        const _checkIfUserBelogsToILocalBox = await this.checkIfUserBelogsToILocalBox();
        const _userAccount = _checkIfUserBelogsToILocalBox && _checkIfUserBelogsToILocalBox[0] && _checkIfUserBelogsToILocalBox[0].parentAccount;
        const _loggedInUserName = _checkIfUserBelogsToILocalBox && _checkIfUserBelogsToILocalBox[0] && _checkIfUserBelogsToILocalBox[0].username;
        if (_loggedInUserName && _loggedInUserName.includes('ilocalbox.com')) {
          localStorage.setItem('isIlocalUser', true);
        } else {
          localStorage.setItem('isIlocalUser', false);
        }
        if (_userAccount.type_id === AccountsTypeEnum.Retailer) {
          localStorage.setItem('isRetail', true);
        } else {
          localStorage.setItem('isRetail', false);
        }
        await this.afterSignInHandler()
        this.setState({ loader: true, secureBadgeErrorMessage: '', encryptedCode: '' })
      } else {
        this.setState({
          loader: false,
          secureBadgeErrorMessage: 'Invalid secure badge code. Please try again.',
          encryptedCode: ''
        })
      }
    } catch (error) {
      console.error('Secure badge authentication failed:', error);
      this.setState({
        loader: false,
        secureBadgeErrorMessage: 'Authentication failed. Please try again later.',
        encryptedCode: ''
      });
    }
  };
  
  render() {
    const { classes, t } = this.props;

    const { isCorporateLogin, ButtonAction } = this.state;
    var settings = {
      dots: true,
      infinite: true,
      autoplay: true,
      arrows: false,
      // className: 'sliderDiv',
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    };
    // Get multi-tab context values
    const { multiTabDetected, multiTabWarningOpen, isDismissing, iconPosition, dismissWarning, showWarning, setIconRef } = this.context || {};
    
    return (
      <div id="ilocalbox-portal-login-root" className={classes.root}>
        {/* Multi-tab warning dialog */}
        <Dialog
          open={multiTabWarningOpen || false}
          aria-labelledby="multi-tab-warning-dialog-title"
          aria-describedby="multi-tab-warning-dialog-description"
          PaperProps={{
            sx: {
              borderRadius: '12px',
              minWidth: '420px',
              maxWidth: '480px',
              overflow: 'hidden',
              boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
              transform: 'translate(0px, 0px) scale(1)',
              opacity: 1,
              transition: 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
              ...(isDismissing && {
                transform: iconPosition 
                  ? `translate(${iconPosition.translateX}px, ${iconPosition.translateY}px) scale(0.05)`
                  : 'translate(400px, -300px) scale(0.05)',
                opacity: 0,
              }),
            }
          }}
          slotProps={{
            backdrop: {
              sx: {
                transition: 'opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                ...(isDismissing && {
                  opacity: '0 !important',
                }),
              }
            }
          }}
        >
          <DialogTitle 
            id="multi-tab-warning-dialog-title" 
            sx={{ 
              background: 'linear-gradient(135deg, #ff9800 0%, #f57c00 100%)',
              color: '#fff',
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              py: 1.75,
              px: 2.5,
              mb: 1,
            }}
          >
            <WarningAmberIcon sx={{ fontSize: '1.6rem' }} />
            <span style={{ fontWeight: 600, fontSize: '1.1rem' }}>
              {t("MultiTab.WarningTitle")}
            </span>
          </DialogTitle>
          <DialogContent sx={{ pt: 3, pb: 1.5, px: 2.5 }}>
            <DialogContentText 
              id="multi-tab-warning-dialog-description"
              sx={{ 
                color: '#424242',
                fontSize: '0.9rem',
                lineHeight: 1.6,
                m: 0,
              }}
            >
              {t("MultiTab.WarningMessage")}
              <br /><br />
              {t("MultiTab.WarningAction")}
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ px: 2.5, pb: 2, pt: 0.5, justifyContent: 'flex-end' }}>
            <NormalButton 
              onClick={dismissWarning} 
              variant="contained"
              autoFocus
              sx={{
                background: 'linear-gradient(135deg, #ff9800 0%, #f57c00 100%)',
                color: '#fff',
                fontWeight: 600,
                px: 3.5,
                py: 0.75,
                borderRadius: '6px',
                textTransform: 'none',
                fontSize: '0.9rem',
                boxShadow: '0 2px 8px rgba(255,152,0,0.3)',
                '&:hover': {
                  background: 'linear-gradient(135deg, #f57c00 0%, #e65100 100%)',
                  boxShadow: '0 4px 12px rgba(255,152,0,0.4)',
                }
              }}
            >
              {t("MultiTab.OkButton")}
            </NormalButton>
          </DialogActions>
        </Dialog>
        
        {/* Multi-tab warning icon (shown when multiple tabs are detected) */}
        {multiTabDetected && (
          <IconButton
            ref={(ref) => setIconRef && setIconRef(ref)}
            onClick={showWarning}
            style={{
              position: 'fixed',
              top: 16,
              right: 16,
              zIndex: 9999,
              backgroundColor: '#fff3cd',
              border: '1px solid #ffc107',
            }}
            title={t("MultiTab.WarningTitle")}
          >
            <WarningAmberIcon style={{ color: '#856404' }} />
          </IconButton>
        )}
        
        <Grid container>
          <Grid item xs={12} md={6}>
            <div className={classes.logoContainer}>
              <Logo />
            </div>
            <div className={classes.mainContentArea}>
              <Paper>
                <Grid container>
                  <Grid item xs={12} sm={6} className={classes.leftAdArea}>
                    <Hidden only={['xs']}>
                      <p className={classes.leftAdAreaText}>
                        {t("Login.LeftAreaHeader")}
                      </p>
                      <Slider
                        {...settings}
                        className={classes.sliderDivContainer}>
                        <div className={classes.sliderDiv}>
                          <img
                            alt='1'
                            width={130}
                            src={slider1}
                            className={classes.chartIcon}
                          />
                        </div>
                        <div className={classes.sliderDiv}>
                          <img
                            alt='2'
                            width={130}
                            src={slider2}
                            className={classes.chartIcon}
                          />
                        </div>
                        <div className={classes.sliderDiv}>
                          <img
                            alt='3'
                            width={130}
                            src={slider3}
                            className={classes.chartIcon}
                          />
                        </div>
                      </Slider>
                    </Hidden>
                  </Grid>
                  <Grid item xs={12} sm={6} className={classes.loginArea}>
                    <div className={classes.loginContent}>
                      {this.state.isSecureBadgeLogin ? (
                        <div>
                          <p className={classes.secureBadgeTitle}>
                            Sign in with secure badge
                          </p>
                          <img
                            sx={{ mt: 12 }}
                            className={classes.brandLogoSize2}
                            src={scanQRImg}
                            alt='scanQR-logo'
                          />
                          {this.state.secureBadgeErrorMessage && (
                            <p style={{ color: 'red', marginTop: 10 }}>
                              {this.state.secureBadgeErrorMessage}
                            </p>
                          )}
                          <FormControl className={classes.invisibleInput}>
                            <InputLabel htmlFor='SecureBadge'>Secure Badge Login</InputLabel>
                            <Input
                              id='SecureBadge'
                              type='text'
                              autoFocus
                              value={this.state.encryptedCode}
                              onChange={(e) => this.setState({ encryptedCode: e.target.value })}
                              onKeyDown={(event) => {
                                if (event.key === 'Enter') {
                                  this.handleSecureBadgeLogin();
                                }
                              }}
                            />
                          </FormControl>
                          <Button
                            className={classes.oktaButton}
                            sx={{ mt: 12 }}
                            onClick={() => {
                              this.setState({
                                isSecureBadgeLogin: false,
                                secureBadgeErrorMessage: ''
                              })
                            }}
                          >
                            Back
                          </Button>
                        </div>
                      ) : !isCorporateLogin ? (
                        <form onSubmit={this.signIn} autoComplete='off'>
                          <img
                            className={classes.brandLogoSize2}
                            src={brandLogo}
                            alt='brand-logo'
                          />
                          <p className={classes.instruction}>
                            {this.state.instruction}
                          </p>
                          {!this.state.user &&
                            !this.state.forgotPasswordSMSFlow && (
                              <div>
                                <FormControl
                                  sx={{ 
                                    m: 1, 
                                    width: { xs: '100%', sm: '31ch' },
                                    maxWidth: { xs: '100%', sm: '31ch' }
                                  }}
                                  variant={'standard'}>
                                  <InputLabel htmlFor='new-username'>
                                    {t("Login.EmailLabel")}
                                  </InputLabel>
                                  <Input
                                    id='new-username'
                                    type='text'
                                    onChange={this.updateUsername}
                                    tabIndex={1}
                                    autoFocus
                                    autoComplete='new-username'
                                    // autoComplete='username'
                                    error={this.state.usernameError}
                                    endAdornment={
                                      <InputAdornment position='end'>
                                        <IconButton disabled>
                                          <AccountCircle />
                                        </IconButton>
                                      </InputAdornment>
                                    }
                                    onKeyDown={(event) => {
                                      if (event.key === 'Enter') {
                                        this.signIn(event);
                                      }
                                    }}
                                  />
                                </FormControl>
                                <FormControl
                                  sx={{ 
                                    m: 1, 
                                    width: { xs: '100%', sm: '31ch' },
                                    maxWidth: { xs: '100%', sm: '31ch' }
                                  }}
                                  variant={'standard'}>
                                  <InputLabel htmlFor='password'>
                                    {t("Login.PasswordLabel")}
                                  </InputLabel>
                                  <Input
                                    id='password'
                                    type='password'
                                    onChange={this.updatePassword}
                                    tabIndex={2}
                                    autoComplete='current-password'
                                    error={this.state.passwordError}
                                    endAdornment={
                                      <InputAdornment position='end'>
                                        <IconButton disabled>
                                          <Lock />
                                        </IconButton>
                                      </InputAdornment>
                                    }
                                    onKeyDown={(event) => {
                                      if (event.key === 'Enter') {
                                        this.signIn(event);
                                      }
                                    }}
                                  />
                                </FormControl>
                                {ButtonAction === 0 ? (
                                  <Stack
                                    direction='row'
                                    spacing={{ xs: 3, sm: 3, md: 2 }}
                                    justifyContent={'center'}
                                    className={classes.buttonBar}>
                                    <NormalButton
                                      className={classes.ternaryButton}
                                      tabIndex={4}
                                      onClick={this.forgotPassword}>
                                      {t("Login.ForgotPasswordButton")}
                                    </NormalButton>
                                    {this.state.user &&
                                      this.state.user.challengeName ===
                                      'NEW_PASSWORD_REQUIRED' && (
                                        <Button
                                          onClick={this.signUp}
                                          type='submit'
                                          variant={'contained'}>
                                          {t("Login.SignUpButton")}
                                        </Button>
                                      )}
                                    {!this.state.user && (
                                      <Button
                                        className={classes.signInButton}
                                        type='submit'
                                        onClick={this.signIn}>
                                        {t("Login.SignInButton")}
                                      </Button>
                                    )}
                                  </Stack>
                                ) : null}
                                <Stack
                                  direction='row'
                                  spacing={{ xs: 3, sm: 3, md: 2 }}
                                  justifyContent={'center'}
                                  className={classes.buttonBar}>
                                  {this.loginType === '' && (
                                    <Button
                                      className={classes.oktaButton}
                                      onClick={this.oktaLogin}
                                      type='submit'
                                      startIcon={
                                        <CircleOutlinedIcon
                                          className={classes.startButtonIcon}
                                        />
                                      }>
                                      {t("Login.SignInOkta")}
                                    </Button>
                                  )}
                                </Stack>
                                <Stack
                                  direction='row'
                                  spacing={{ xs: 3, sm: 3, md: 2 }}
                                  justifyContent={'center'}
                                  className={classes.buttonBar}>
                                  {this.loginType === '' && (
                                    <Button
                                      className={classes.pingButton}
                                      onClick={this.pingOIDCLogin}
                                      type='submit'
                                      startIcon={
                                        <h1 className={classes.startButtonIcon}>
                                          P
                                        </h1>
                                      }>
                                      {/* <img
                                          src='https://console.pingone.com/favicon.ico'
                                          alt='PingOne'
                                        /> */}
                                      {t("Login.SignInPing")}
                                    </Button>
                                  )}
                                </Stack>
                                <Stack
                                  direction='row'
                                  spacing={{ xs: 3, sm: 3, md: 2 }}
                                  justifyContent={'center'}
                                  className={classes.buttonBar}>
                                  {this.loginType === '' && (
                                    <Button
                                      className={classes.oktaButton}
                                      onClick={this.samlLogin}
                                      type='submit'
                                    // startIcon={
                                    //   <img
                                    //     src='https://www.sigcorp.com/wp-content/uploads/2020/06/SAML-Logo-e1592426354492.png'
                                    //     alt='SAML 2.0'
                                    //   />
                                    // }
                                    >
                                      {t("Login.SignInSaml")}
                                    </Button>
                                  )}
                                </Stack>
                                <Stack
                                  direction='row'
                                  spacing={{ xs: 3, sm: 3, md: 2 }}
                                  justifyContent={'center'}
                                  className={classes.buttonBar}>
                                  {this.loginType === '' && (
                                    <Button
                                      className={classes.oktaButton}
                                      onClick={() => this.setState({ isSecureBadgeLogin: true })}
                                      type='submit'
                                    >
                                      Login with Secure Badge
                                    </Button>
                                  )}
                                </Stack>
                              </div>
                            )}
                          {this.state.forgotPasswordSMSFlow && (
                            <div>
                              <FormControl
                                sx={{ 
                                  m: 1, 
                                  width: { xs: '100%', sm: '31ch' },
                                  maxWidth: { xs: '100%', sm: '31ch' }
                                }}
                                variant={'standard'}>
                                <InputLabel htmlFor='smsCode'>
                                  {t("Login.VerificationCodeTitle")}
                                </InputLabel>
                                <Input
                                  id='smsCode'
                                  onChange={this.updateSMSCode}
                                  tabIndex={2}
                                  error={this.state.smsCodeError}
                                  endAdornment={
                                    <InputAdornment position='end'>
                                      <IconButton disabled>
                                        <Lock />
                                      </IconButton>
                                    </InputAdornment>
                                  }
                                  onKeyDown={(event) => {
                                    if (event.key === 'Enter') {
                                      this.signIn(event);
                                    }
                                  }}
                                />
                              </FormControl>
                              <FormControl
                                sx={{ 
                                  m: 1, 
                                  width: { xs: '100%', sm: '31ch' },
                                  maxWidth: { xs: '100%', sm: '31ch' }
                                }}
                                variant={'standard'}>
                                <InputLabel htmlFor='password'>
                                  {t("Login.NewPasswordTitle")}
                                </InputLabel>
                                <Input
                                  id='password'
                                  type='password'
                                  onChange={this.updateResetNewPassword}
                                  tabIndex={2}
                                  autoComplete='current-password'
                                  error={this.state.ResetNewPasswordError}
                                  endAdornment={
                                    <InputAdornment position='end'>
                                      <IconButton
                                        disabled
                                        aria-label='new password visibility'>
                                        <Lock />
                                      </IconButton>
                                    </InputAdornment>
                                  }
                                  onKeyDown={(event) => {
                                    if (event.key === 'Enter') {
                                      this.signIn(event);
                                    }
                                  }}
                                />
                              </FormControl>
                              <FormControl
                                sx={{ 
                                  m: 1, 
                                  width: { xs: '100%', sm: '31ch' },
                                  maxWidth: { xs: '100%', sm: '31ch' }
                                }}
                                variant={'standard'}>
                                <InputLabel htmlFor='password'>
                                  {t("Login.ConfirmNewPasswordTitle")}
                                </InputLabel>
                                <Input
                                  id='confirmPassword'
                                  type='password'
                                  onChange={this.updateResetConfirmPassword}
                                  tabIndex={3}
                                  autoComplete='confirm-password'
                                  error={this.state.resetConfirmPasswordError}
                                  endAdornment={
                                    <InputAdornment position='end'>
                                      <IconButton
                                        disabled
                                        aria-label='change new password visibility'>
                                        <Lock />
                                      </IconButton>
                                    </InputAdornment>
                                  }
                                  onKeyDown={(event) => {
                                    if (event.key === 'Enter') {
                                      this.signIn(event);
                                    }
                                  }}
                                />
                              </FormControl>
                              <Stack
                                direction='row'
                                spacing={{ xs: 2, sm: 2, md: 3 }}
                                justifyContent={'center'}
                                style={{
                                  paddingBottom: '1rem',
                                  paddingTop: '1rem',
                                }}>
                                <Button
                                  onClick={this.forgotPasswordSubmit}
                                  className={classes.signInButton}
                                  variant={'contained'}
                                  type='submit'>
                                  {t("Login.ResetPasswordTitle")}
                                </Button>
                              </Stack>
                            </div>
                          )}
                          {this.state.user &&
                            this.state.user.challengeName ===
                            'NEW_PASSWORD_REQUIRED' && (
                              <div>
                                <FormControl
                                  sx={{ 
                                    m: 1, 
                                    width: { xs: '100%', sm: '31ch' },
                                    maxWidth: { xs: '100%', sm: '31ch' }
                                  }}
                                  variant={'standard'}>
                                  <InputLabel htmlFor='name'>{t("Login.NameTitle")}</InputLabel>
                                  <Input
                                    id='name'
                                    type='text'
                                    // onChange={this.updateName}
                                    tabIndex={1}
                                    autoFocus
                                    autoComplete='name'
                                    // error={this.state.nameError}
                                    // defaultValue={this.state.userEmail}
                                    defaultValue={this.state.userEmail}
                                    readOnly
                                    endAdornment={
                                      <InputAdornment position='end'>
                                        <IconButton disabled>
                                          <AccountCircle />
                                        </IconButton>
                                      </InputAdornment>
                                    }
                                    onKeyDown={(event) => {
                                      if (event.key === 'Enter') {
                                        this.signIn(event);
                                      }
                                    }}
                                  />
                                </FormControl>
                                <FormControl
                                  sx={{ 
                                    m: 1, 
                                    width: { xs: '100%', sm: '31ch' },
                                    maxWidth: { xs: '100%', sm: '31ch' }
                                  }}
                                  variant={'standard'}>
                                  <InputLabel htmlFor='password'>
                                    {t("Login.NewPasswordTitle")}
                                  </InputLabel>
                                  <Input
                                    id='password'
                                    type='password'
                                    onChange={this.updateNewPassword}
                                    tabIndex={2}
                                    autoComplete='current-password'
                                    error={this.state.newPasswordError}
                                    endAdornment={
                                      <InputAdornment position='end'>
                                        <IconButton disabled>
                                          <Lock />
                                        </IconButton>
                                      </InputAdornment>
                                    }
                                    onKeyDown={(event) => {
                                      if (event.key === 'Enter') {
                                        this.signIn(event);
                                      }
                                    }}
                                  />
                                </FormControl>
                                <FormControl
                                  sx={{ 
                                    m: 1, 
                                    width: { xs: '100%', sm: '31ch' },
                                    maxWidth: { xs: '100%', sm: '31ch' }
                                  }}
                                  variant={'standard'}>
                                  <InputLabel htmlFor='password'>
                                    {t("Login.ConfirmNewPasswordTitle")}
                                  </InputLabel>
                                  <Input
                                    id='confirmPassword'
                                    type='password'
                                    onChange={this.updateConfirmPassword}
                                    tabIndex={3}
                                    autoComplete='confirm-password'
                                    error={this.state.confirmPasswordError}
                                    endAdornment={
                                      <InputAdornment position='end'>
                                        <IconButton disabled>
                                          <Lock />
                                        </IconButton>
                                      </InputAdornment>
                                    }
                                    onKeyDown={(event) => {
                                      if (event.key === 'Enter') {
                                        this.signIn(event);
                                      }
                                    }}
                                  />
                                </FormControl>
                                <Stack
                                  direction='row'
                                  spacing={{ xs: 4, sm: 4, md: 3 }}
                                  justifyContent={'center'}
                                  className={classes.buttonBar}>
                                  {this.state.user &&
                                    this.state.user.challengeName ===
                                    'NEW_PASSWORD_REQUIRED' && (
                                      <Button
                                        onClick={this.signUp}
                                        type='submit'
                                        className={classes.signInButton}>
                                        {t("Login.SignUpButton")}
                                      </Button>
                                    )}
                                  {!this.state.user && (
                                    <Button
                                      onClick={this.signIn}
                                      type='submit'
                                      className={classes.signInButton}>
                                      {t("Login.SignInButton")}
                                    </Button>
                                  )}
                                </Stack>
                              </div>
                            )}
                        </form>
                      ) : (
                        <form onSubmit={this.handleCorporateLogin} autoComplete='off'>
                          <img
                            className={classes.brandLogoSize2}
                            src={brandLogo}
                            alt='brand-logo'
                          />
                          <p className={classes.instruction}>
                            {this.state.instruction}
                          </p>
                          <div className={classes.oktaFormContainer}>
                            <FormControl
                              sx={{ 
                                m: 1, 
                                width: { xs: '100%', sm: '31ch' },
                                maxWidth: { xs: '100%', sm: '31ch' }
                              }}
                              variant={'standard'}>
                              <InputLabel htmlFor='new-username'>
                                {t("Login.YourEmailTitle")}
                              </InputLabel>
                              <Input
                                id='new-username'
                                type='text'
                                onChange={this.updateUsername}
                                tabIndex={1}
                                autoFocus
                                autoComplete='new-username'
                                error={this.state.usernameError}
                                endAdornment={
                                  <InputAdornment position='end'>
                                    <IconButton disabled>
                                      <AccountCircle />
                                    </IconButton>
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                            <Stack
                              direction='row'
                              spacing={{ xs: 3, sm: 3, md: 2 }}
                              justifyContent={'center'}
                              className={classes.buttonBar}
                              style={{ paddingTop: '2rem' }}>
                              <Button
                                className={
                                  this.loginType === 'okta'
                                    ? classes.oktaContinueButton
                                    : this.loginType === 'pingOIDC'
                                      ? classes.pingContinueButton
                                      : classes.ternaryButton
                                }
                                onClick={this.handleGoBack}
                                startIcon={
                                  <ArrowCircleLeftOutlinedIcon
                                    className={classes.startButtonIcon}
                                  />
                                }>
                                {t("Login.GoBackTitle")}
                              </Button>
                              <Button
                                className={
                                  this.loginType === 'okta'
                                    ? classes.oktaContinueButton
                                    : this.loginType === 'pingOIDC'
                                      ? classes.pingContinueButton
                                      : classes.ternaryButton
                                }
                                onClick={this.handleCorporateLogin}
                                type='submit'
                                startIcon={
                                  <CircleOutlinedIcon
                                    className={classes.startButtonIcon}
                                  />
                                }>
                                {t("Login.ContinueTitle")}
                              </Button>
                            </Stack>
                          </div>
                        </form>
                      )}
                    </div>
                  </Grid>
                </Grid>
              </Paper>
            </div>
            <div className={classes.footer}>
              <LanguageToggle />
              <span>
                &copy; 2018 - {new Date().getFullYear()}{' '}
                <a
                  target='new'
                  style={{ color: '#115E67', textDecoration: 'none' }}
                  href='https://ilocalbox.com/'>
                  ilocalbox.com
                </a>
                . {t("Login.Footer")}
              </span>
            </div>
          </Grid>
          {(
            <Grid item xs={12} md={6}>
              <div className={classes.rightmaincontent}>
              <div className={classes.sectionContainer}>
                <div className={classes.kaktusLogo}>
                  <img src={KaktusTopLogo} alt='Kaktus Logo' />
                </div>
                <div
                  className={classes.LearnHowTo}>
                  {t("Login.LearnHowTitle_1")}&nbsp;
                  <span className={classes.hithLightedFont}>
                    {t("Login.LearnHowTitle_2")}
                  </span>
                  &nbsp;{t("Login.LearnHowTitle_3")}
                </div>
                <div
                  className={classes.kaktusConcierge}>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-evenly',
                      alignItems: 'center',
                    }}>
                    <img
                      src={KaktusMobile}
                      style={{ width: '8%' }}
                      alt='Kaktus Mobile'
                    />
                    <img
                      src={KaktusConcierge}
                      style={{ width: '8%' }}
                      alt='Kaktus Concierge'
                    />
                    <img
                      src={KaktusDeliver}
                      style={{ width: '8%' }}
                      alt='Kaktus Deliver'
                    />
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-evenly',
                      alignItems: 'center',
                    }}>
                    <label
                      style={{ paddingLeft: '15px' }}
                      className={classes.BrandInfo}>
                      {t("Login.KaktusMobileImageTitle")}
                    </label>
                    <label
                      style={{ marginRight: '-10px' }}
                      className={classes.BrandInfo}>
                      {t("Login.KaktusConciergeImageTitle")}
                    </label>
                    <label className={classes.BrandInfo}>{t("Login.KaktusDeliverImageTitle")}</label>
                  </div>
                </div>
                <Paper sx={{ 
                  marginTop: '1%', 
                  padding: '15px', 
                  position: { xs: 'relative', md: 'absolute' },
                  width: { xs: '100%', md: '44%' },
                  marginBottom: { xs: '2rem', md: '0' }
                }}>
                  <center>
                    <p className={classes.didYouKnow}>{t("Login.DidYouKnowTitle")}</p>
                    <p className={classes.isILocaBox}>
                      {t("Login.ILocalBoxIsPoweredByKaktus")}
                    </p>
                    <div>
                      <img
                        src={KaktusPoweredByGrey}
                        style={{ width: '20%' }}
                        alt='Kaktus Powered By'
                      />
                    </div>
                  </center>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-evenly',
                      alignItems: 'center',
                      marginTop: '-3%',
                    }}>
                    <div className={classes.didYouKnowImages}>
                      <img
                        src={IlocalCurbside}
                        alt='Curbside'
                      />
                      <label className={classes.iBrandInfo}>
                        {t("Login.CurbsideImageTitle")}
                      </label>
                    </div>
                    <div className={classes.didYouKnowImages}>
                      <img
                        src={IlocalKiosk}
                        alt='Kiosk'
                      />
                      <label
                        className={classes.iBrandInfo}
                        style={{ marginLeft: '4%', marginRight: '4%' }}>
                        {t("Login.KioskImageTitle")}
                      </label>
                    </div>
                    <div className={classes.didYouKnowImages}>
                      <img
                        src={IlocalMail}
                        alt='Mail Order'
                      />
                      <label className={classes.iBrandInfo}>{t("Login.MailOrderImageTitle")}</label>
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-evenly',
                      alignItems: 'center',
                    }}>
                    <div className={classes.didYouKnowImages}>
                      <img
                        src={IlocalCounter}
                        alt='Counter'
                      />
                      <label className={classes.iBrandInfo}>
                        {t("Login.CounterImageTitle")}
                      </label>
                    </div>
                    <div className={classes.didYouKnowImages}>
                      <img
                        src={IlocalCourier}
                        alt='Courier'
                      />
                      <label
                        className={classes.iBrandInfo}
                        style={{ marginLeft: '4%', marginRight: '4%' }}>
                        {t("Login.CourierImageTitle")}
                      </label>
                    </div>
                    <div className={classes.didYouKnowImages}>
                      <img
                        src={IlocalBedside}
                        alt='Meds-to-Beds'
                      />
                      <label className={classes.iBrandInfo}>{t("Login.MedsToBedsImageTitle")}</label>
                    </div>
                  </div>
                </Paper>
              </div>
              <div className={classes.kaktusBottom}>
                <img
                  src={KaktusBottom}
                  style={{ width: '100%' }}
                  alt='Kaktus Bottom'
                />
              </div>
            </div>
          </Grid>
          )}
        </Grid>
        {this.state.loader ? (
          <div className={classes.spinner}>
            <img className={classes.spinnerImage} src={spinner} alt='loading' />
          </div>
        ) : null}
        <Dialog
          open={this.state.mfa}
          onClose={() =>
            this.setState({
              mfa: false,
              otpSent: false,
              otpError: '',
              otpSuccess: '',
              loader: false,
            })
          }
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
          className={classes.diagnostics_dialogbox}>
          <DialogTitle
            id='form-dialog-title'
            sx={{ justifyContent: 'end !important' }}>
            <IconButton onClick={() => this.setState({ mfa: false })}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            onClick={(e) => {
              this.onFocusEventHandler('otp' + this.state.otp.length - 1);
              e.preventDefault();
            }}>
            <Box
              display='block'
              justifyContent='center'
              alignItems='center'
              textAlign='center'>
              <Box display='flex' justifyContent='center' alignItems='center'>
                <Typography
                  variant='h2'
                  color='#494949'
                  fontSize='24px'
                  fontWeight='600'
                  fontFamily='SF Pro Display,SF Pro Icons,Helvetica Neue,Helvetica,Arial,sans-serif'
                  letterSpacing='.009em'
                  lineHeight='1.16667'>
                  {t("Login.TwoFactorAuthentication")}
                </Typography>
              </Box>
              <Box display='flex' justifyContent='center' alignItems='center'>
                {this.state.otpError && (
                  <Box
                    display='flex'
                    justifyContent='center'
                    alignItems='center'
                    mt={5}>
                    <Typography
                      variant='h2'
                      color='red'
                      fontSize='24px'
                      fontWeight='600'
                      fontFamily='SF Pro Display,SF Pro Icons,Helvetica Neue,Helvetica,Arial,sans-serif'
                      letterSpacing='.009em'
                      lineHeight='1.16667'>
                      {this.state.otpError}
                    </Typography>
                  </Box>
                )}
                {this.state.otpSuccess && (
                  <Box
                    display='flex'
                    justifyContent='center'
                    alignItems='center'
                    mt={5}>
                    <Typography
                      variant='h2'
                      color='limegreen'
                      fontSize='24px'
                      fontWeight='600'
                      fontFamily='SF Pro Display,SF Pro Icons,Helvetica Neue,Helvetica,Arial,sans-serif'
                      letterSpacing='.009em'
                      lineHeight='1.16667'>
                      {this.state.otpSuccess}
                    </Typography>
                  </Box>
                )}
              </Box>
              <Box mt={5}>
                {Array(6)
                  .fill()
                  .map((_, i) => (
                    <input
                      key={i}
                      id={`otp${i}`}
                      name='otp'
                      ref={`otp${i}`}
                      autoComplete='off'
                      autoFocus={i === 0}
                      onKeyDown={(e) => this.onKeyPress(i, e)}
                      className={classes.pickupCodeInput}
                      maxLength={1}
                    />
                  ))}
              </Box>
              <span
                className={classes.clearButton}
                onClick={this.onResetOTPInputs}>
                {t("Login.ClearTitle")}
              </span>
              <Box mt={4}>
                <Typography
                  variant='p'
                  fontSize='17px'
                  lineHeight='1.47059'
                  fontWeight='400'
                  letterSpacing='-.022em'
                  fontFamily='SF Pro Text,SF Pro Icons,Helvetica Neue,Helvetica,Arial,sans-serif'
                  color='#494949'>
                  {t("Login.VerificationCodeSent_1")} <br />
                  {t("Login.VerificationCodeSent_2")}
                </Typography>
                <Box mt={3}>
                  <Link
                    underline='none'
                    mt={2}
                    color='#0070c9'
                    sx={{ cursor: 'pointer' }}
                    onClick={this.signIn}>
                    {t("Login.DidNotGetVerificationCode")}
                  </Link>
                </Box>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(withTranslation()(Login));



// WEBPACK FOOTER //
// ./src/components/login/index.js